import { OverlayState } from './types/reducerTypes'
import { AnyAction } from 'redux'
import { triggerSentryError } from '../../../shared/helpers.js'
import { setScreenLoggerVisibility } from '../../../shared/screenLogger'
import { setMemoryLoggerVisibility } from '../../../shared/memoryLogger'

const defaultState: OverlayState = {
  enabled: false,
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'TOGGLE_OVERLAY':
      if (!state.enabled) {
        const randomInteger = Math.floor(Math.random() * 10)
        console.error('FORCING ERROR', randomInteger)
        triggerSentryError('FORCED', 'FORCED', {
          randomInteger,
          errorMessage: 'FORCED',
        })
        setScreenLoggerVisibility(true)
        setMemoryLoggerVisibility(true)
      } else {
        setScreenLoggerVisibility(false)
        setMemoryLoggerVisibility(false)
      }
      return { ...state, enabled: !state.enabled }
    default:
      return state
  }
}
